<section class="features container" *ngIf="data.property_features.length > 0">

  <h4 id="realty-features-title">Características do imóvel</h4>

  <ul id="realty-features" class="hideable" [class.hide]="hideRealtyFeatures === true">
    <li *ngFor="let item of data.property_features">
      <img id="{{item.name}}-rfi" src="/assets/svgs/product-details/{{item.type}}.svg" [alt]="item.name" onerror="this.src='/assets/svgs/product-details/default.svg'">
      <span id="{{item.name}}-rft">{{item.name}}</span>
    </li>
  </ul>

  <a id="show-realty-features" (click)="hideRealtyFeatures = !hideRealtyFeatures">Ver menos</a>

</section>

<section class="features container" *ngIf="data.condominium_features.length > 0">

  <h4 id="condo-features-title">Características do condomínio</h4>

  <ul id="condo-features" class="hideable" [class.hide]="hideCondoFeatures === true">
    <li *ngFor="let item of data.condominium_features">
      <img src="/assets/svgs/product-details/{{item.type}}.svg" [alt]="item.name" onerror="this.src='/assets/svgs/product-details/default.svg'">
      <span class="text" id="{{item.type}}-cft">{{item.name}}</span>
    </li>
  </ul>

  <a id="show-condo-features" (click)="hideCondoFeatures = !hideCondoFeatures">Ver menos</a>

</section>